// ─── URL Constants ────────────────────────────────────────────────────

import { FUtil } from '@freelog/tools-lib';

export const AVATAR_URL_PREFIX = FUtil.Domain.IMAGE_ORIGIN + '/avatar/';

export const DEFAULT_COVER_URL = FUtil.Domain.STATIC_ORIGIN + '/static/default_cover.png';

export const { isTestEnv, isDevEnv, isProdEnv, getMicroAppName } = FUtil.Domain;

// ─── API Subject Types ───────────────────────────────────────────────

export const SUBJECT_TYPE = {
  RESOURCE: 1,
  EXHIBIT: 2,
  USER_GROUP: 3,
  COLLECTION: 4,
} as const;

export const LICENSEE_IDENTITY = {
  RESOURCE: 1,
  NODE: 2,
} as const;

// ─── List / Page State ──────────────────────────────────────────────

export type ListState = 'loading' | 'noData' | 'noSearchResult' | 'loaded';
export type ListMore = 'loading' | 'andMore' | 'noMore';

// ─── Contract Status ─────────────────────────────────────────────────

export type ContractStatus = 'active' | 'testActive' | 'inactive' | 'terminal';

// ─── MIME Types ──────────────────────────────────────────────────────

export const MIME_FREELOG_COMIC = 'application/vnd.freelog.comic';
